module.exports = __webpack_public_path__ + "img/9a54316.png";